module.exports = __webpack_public_path__ + "static/media/Tuto_acceder_a_la visio_BBB_parent.3a7f0ec7.pdf";